// extracted by mini-css-extract-plugin
export var closeButton = "_fo-2";
export var closeButtonIcon = "_fo-3";
export var lightboxContent = "_fo-1";
export var lightboxOverlay = "_fo-0";